import { Button, Modal } from "react-bootstrap"

const ConfirmModalComponent = ({size, title, body, handleClose, handleSubmit, show}) => {

    return <>
      <Modal 
      show={show} 
      onHide={handleClose}
      size={size}
      >
        <Modal.Header closeButton>
            <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
            <Modal.Body>{body}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            No
          </Button>
          <Button variant="primary" onClick={handleSubmit}>
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    </>
}

export default ConfirmModalComponent 